import { createSelector } from 'reselect';

const selectOBNPMappins = (state: any) => state.obnpMappings;


export const selectOBNPMappinsCurrentItem = createSelector([selectOBNPMappins], (obnpMappings) => obnpMappings.current);

export const selectOBNPMappinsListItems = createSelector([selectOBNPMappins], (obnpMappings) => obnpMappings.list);

export const selectOBNPMappinsItemById = (itemId: any) =>
    createSelector(selectOBNPMappinsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectOBNPMappinsQueryItems = createSelector([selectOBNPMappins], (obnpMappings) => obnpMappings.query);

export const selectOBNPMappinsCreatedItem = createSelector([selectOBNPMappins], (obnpMappings) => obnpMappings.create);

export const selectOBNPMappinsUpdatedItem = createSelector([selectOBNPMappins], (obnpMappings) => obnpMappings.update);

export const selectOBNPMappinsReadItem = createSelector([selectOBNPMappins], (obnpMappings) => obnpMappings.read);

export const selectOBNPMappinsDeletedItem = createSelector([selectOBNPMappins], (obnpMappings) => obnpMappings.delete);

export const selectOBNPMappinsearchedItems = createSelector([selectOBNPMappins], (obnpMappings) => obnpMappings.search);

export const selectOBNPMappinsItemsCount = createSelector([selectOBNPMappins], (obnpMappings) => obnpMappings.count);

export const selectOBNPMappinsItemsFilter = createSelector([selectOBNPMappins], (obnpMappings) => obnpMappings.filter);